"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FigspecFileViewer = exports.FigspecFrameViewer = void 0;
const FigspecFrameViewer_1 = require("./FigspecViewer/FigspecFrameViewer");
Object.defineProperty(exports, "FigspecFrameViewer", { enumerable: true, get: function () { return FigspecFrameViewer_1.FigspecFrameViewer; } });
const FigspecFileViewer_1 = require("./FigspecViewer/FigspecFileViewer");
Object.defineProperty(exports, "FigspecFileViewer", { enumerable: true, get: function () { return FigspecFileViewer_1.FigspecFileViewer; } });
if (!customElements.get("figspec-file-viewer")) {
    customElements.define("figspec-file-viewer", FigspecFileViewer_1.FigspecFileViewer);
}
if (!customElements.get("figspec-frame-viewer")) {
    customElements.define("figspec-frame-viewer", FigspecFrameViewer_1.FigspecFrameViewer);
}
